import React from 'react';
import { Button } from 'fronton-react';
import { cn } from 'utils/classnames';
import { ShortArrow } from '../../icons/short-arrow';
import { ButtonLabeled, Props } from './carousel-control.types';
import { buttonStyle } from './carousel-control.styles';

export const CarouselControl: React.FC<Props> = ({
  direction = 'left',
  onClick,
  variant,
  size,
  rounded,
  iconOnly,
  label,
  iconSize,
  className,
  ...props
}) => (
  <Button
    className={cn(className, buttonStyle, direction === 'left' ? 'left' : 'right')}
    kind="regular"
    variant={variant}
    size={size}
    {...(rounded && { rounded: true })}
    {...(iconOnly && { iconOnly: true })}
    label={label || ''}
    onClick={onClick}
    {...(props as ButtonLabeled)}
  >
    <ShortArrow iconSize={iconSize} direction={direction} />
  </Button>
);
